import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { PER_PAGE_OPTIONS } from './types'

/**
 * Itens por página. 10 é pouco para as telas de triagem — quem está caçando cadastro
 * incompleto depois da migração passa mais tempo paginando do que olhando a lista.
 * O backend clampa o valor (ListPagination), então mexer na URL não derruba a tela.
 */
export function PerPageSelect({
  value,
  onChange,
}: {
  value: number
  onChange: (perPage: number) => void
}) {
  return (
    <div className="flex items-center gap-2 text-sm text-muted-foreground">
      <span>Por página</span>
      <Select
        value={String(value)}
        onValueChange={(next) => onChange(Number(next))}
      >
        <SelectTrigger className="h-8 w-[72px]" aria-label="Itens por página">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {PER_PAGE_OPTIONS.map((option) => (
            <SelectItem key={option} value={String(option)}>
              {option}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
